import { BASE_CLASS_PREFIX } from '../base/constants';

const cssClasses = {
    PREFIX: `${BASE_CLASS_PREFIX}-card`
};

const strings = {
    SHADOWS: ['hover', 'always'],
    TYPE: ['grid']
};

export {
    cssClasses,
    strings
};